import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const CF_RE = /^[A-Za-z0-9]{16}$/;

export default function RegisterPage() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nome: "", cognome: "", codice_fiscale: "", email: "", password: "", conferma_password: "", privacy: false,
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!EMAIL_RE.test(form.email.trim())) {
      setError("Inserisci un indirizzo email valido");
      return;
    }
    if (!CF_RE.test(form.codice_fiscale.trim())) {
      setError("Codice Fiscale non valido: devono essere 16 caratteri alfanumerici");
      return;
    }
    if (form.password.length < 8) {
      setError("La password deve contenere almeno 8 caratteri");
      return;
    }
    if (form.password !== form.conferma_password) {
      setError("Le password non coincidono");
      return;
    }
    if (!form.privacy) {
      setError("Devi accettare le regole sulla privacy per completare la registrazione");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post("/auth/register", form);
      setUser(res.data);
      navigate("/area-personale");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16 sm:px-6 animate-fade-up" data-testid="register-page">
      <div className="card-elegant">
        <h1 className="font-heading text-2xl font-bold text-bordeaux-dark sm:text-3xl">Iscriviti</h1>
        <p className="mt-2 text-sm text-muted-foreground">Crea il tuo account ENPALSBOX in pochi minuti.</p>

        {error && (
          <div data-testid="register-error" className="mt-4 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
            {error}
          </div>
        )}

        <form onSubmit={submit} noValidate className="mt-6 space-y-4" data-testid="register-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label className="label-elegant" htmlFor="reg-nome">Nome *</label>
              <input id="reg-nome" data-testid="register-nome-input" className="input-elegant" required value={form.nome} onChange={set("nome")} />
            </div>
            <div>
              <label className="label-elegant" htmlFor="reg-cognome">Cognome *</label>
              <input id="reg-cognome" data-testid="register-cognome-input" className="input-elegant" required value={form.cognome} onChange={set("cognome")} />
            </div>
          </div>
          <div>
            <label className="label-elegant" htmlFor="reg-cf">Codice Fiscale *</label>
            <input id="reg-cf" data-testid="register-codice-fiscale-input" className="input-elegant uppercase" required maxLength={16}
              placeholder="ES. RSSMRA80A01H501U" value={form.codice_fiscale} onChange={set("codice_fiscale")} />
          </div>
          <div>
            <label className="label-elegant" htmlFor="reg-email">Email *</label>
            <input id="reg-email" type="email" data-testid="register-email-input" className="input-elegant" required value={form.email} onChange={set("email")} />
          </div>
          <div>
            <label className="label-elegant" htmlFor="reg-password">Password *</label>
            <input id="reg-password" type="password" data-testid="register-password-input" className="input-elegant" required minLength={8}
              value={form.password} onChange={set("password")} />
            <p className="mt-1 text-xs text-muted-foreground">Minimo 8 caratteri.</p>
          </div>
          <div>
            <label className="label-elegant" htmlFor="reg-conferma">Conferma Password *</label>
            <input id="reg-conferma" type="password" data-testid="register-conferma-password-input" className="input-elegant" required
              value={form.conferma_password} onChange={set("conferma_password")} />
          </div>
          <label className="flex items-start gap-3 text-sm text-foreground/80" data-testid="register-privacy-label">
            <input type="checkbox" data-testid="register-privacy-checkbox" className="mt-0.5 h-4 w-4 accent-[#7A1C30]"
              checked={form.privacy} onChange={set("privacy")} />
            Accetto le regole sulla privacy *
          </label>
          <button type="submit" disabled={loading} data-testid="register-submit-button" className="btn-bordeaux w-full">
            {loading ? "REGISTRAZIONE IN CORSO..." : "ISCRIVITI"}
          </button>
        </form>

        <p className="mt-5 text-center text-sm text-muted-foreground">
          Hai già un account?{" "}
          <Link to="/accedi" data-testid="register-login-link" className="font-semibold text-bordeaux hover:underline">
            Accedi
          </Link>
        </p>
      </div>
    </div>
  );
}
